export function foreseeableChangesBuilderForMyCRM(foreseeableChanges) {
  return {
    client_id: foreseeableChanges.clientId,
    details: foreseeableChanges.details,
  };
}
